const features = [
  {
    icon: 'ri-shield-check-line',
    title: 'Safety First',
    description: 'We follow strict sterilization protocols and use only high-quality, hypoallergenic jewelry to ensure your safety and comfort.'
  },
  {
    icon: 'ri-star-line',
    title: 'Jewelry Included',
    description: 'Every piercing comes with premium jewelry. Choose from our extensive collection of surgical steel, titanium, and gold options.'
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Expert Artists',
    description: 'Our experienced piercers Tia and Justin bring years of expertise and artistic vision to every piercing they perform.'
  },
  {
    icon: 'ri-door-open-line',
    title: 'Walk-Ins Welcome',
    description: 'No appointment necessary! Visit either of our two convenient Wichita locations whenever it works for your schedule.'
  }
];

export default function About() {
  return (
    <section id="about" className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Wichita's Premier Piercing Studio
            </h2>
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              Another Piercing Co is Wichita's trusted destination for professional body piercing services. Located in the heart of Wichita at 551 West Douglas Ave, we've built our reputation on providing exceptional piercing experiences with a focus on safety, artistry, and customer satisfaction.
            </p>
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              Our team of expert piercers, Tia and Justin, brings years of experience and passion to every piercing. We specialize in all types of piercings including ear, facial, and body piercings, and we pride ourselves on creating a welcoming, professional environment where clients feel comfortable and confident.
            </p>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              With two convenient locations in Wichita and a walk-in friendly policy, we make it easy to get the piercing you've been dreaming of. Every piercing includes high-quality jewelry and comprehensive aftercare instructions to ensure proper healing.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="tel:3163057076"
                className="bg-red-600 text-white px-8 py-3 rounded-lg hover:bg-red-700 transition-colors font-bold cursor-pointer whitespace-nowrap text-center inline-block"
              >
                Call Justin
              </a>
              <a 
                href="tel:3168807760"
                className="bg-red-600 text-white px-8 py-3 rounded-lg hover:bg-red-700 transition-colors font-bold cursor-pointer whitespace-nowrap text-center inline-block"
              >
                Call Tia
              </a>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/51511adac1b079a8a11b7492db60f76d.jpeg"
              alt="Another Piercing Co Studio"
              className="w-full h-[600px] object-cover object-top rounded-2xl shadow-2xl"
            />
            <div className="absolute -bottom-6 -left-6 bg-red-600 text-white p-6 rounded-xl shadow-xl max-w-xs">
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-map-pin-line text-3xl"></i>
                <div>
                  <p className="font-bold text-lg">Two Locations</p>
                  <p className="text-sm text-white/90">Serving Wichita, KS</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center bg-gray-800 p-6 rounded-xl hover:bg-gray-750 transition-colors">
              <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-xl mx-auto mb-4">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
